import { render, staticRenderFns } from "./ButtonCertificate.vue?vue&type=template&id=74ffc56e&scoped=true&"
import script from "./ButtonCertificate.vue?vue&type=script&lang=js&"
export * from "./ButtonCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ffc56e",
  null
  
)

export default component.exports